// Polish translations
export const pl = {
  // Common
  common: {
    home: 'Strona główna',
    settings: 'Ustawienia',
    language: 'Język',
    loading: 'Ładowanie...',
    save: 'Zapisz',
    cancel: 'Anuluj',
    confirm: 'Potwierdź',
    close: 'Zamknij',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Ustawienia',
    home: 'Strona główna',
    howToPlay: 'Jak grać',
    pieceRules: 'Zasady figur',
    language: 'Język',
    manageSubscription: 'Zarządzaj subskrypcją',
    gameHistory: 'Historia gier',
    analytics: 'Analityka',
    premiumAccount: 'Konto premium',
    chatEnabled: 'Czat: Włączony',
    chatDisabled: 'Czat: Wyłączony',
  },

  // Piece Rules
  pieceRules: {
    title: 'Zasady figur',
    description: 'Poznaj ruchy figur',
    selectPiece: 'Wybierz figurę',
    selectedLabel: 'Wybrano:',
    statusLabel: 'Status:',
    statusReady: 'Gotowy',
    statusViewing: 'Przeglądanie',
    movement: 'Ruch',
    regularMovement: 'Zwykły ruch',
    ability: 'Zdolność',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Ruch',
    savage: 'Dzikość',
    birdtype: 'Typ ptaka',
    birdType: 'Typ ptaka',
    wallBlock: 'Blokada ściany',
    moveblocks: 'Blokady ruchu',
    wallclimb: 'Wspinaczka po ścianie',
    lilypad: 'Lilia wodna',
    poisonous: 'Trujący',
    meadow: 'Łąka',
    parasiticfungi: 'Pasożytniczy grzyb',
    zombification: 'Zombifikacja',
    fungi: 'Grzyb',
    traverse: 'Przemierzanie',
    capture: 'Bicie',
    faint: 'Zemdlenie',
    leap: 'Skok',
    swing: 'Huśtawka',
    consume: 'Pochłonięcie',
    gamble: 'Hazard',
    entangle: 'Oplątanie',
    ink: 'Atrament',
    rotate: 'Obrót',
    backstep: 'Krok wstecz',
    trample: 'Tratowanie',
    charge: 'Szarża',
    lane: 'Tor',
    snakestrike: 'Atak węża',
    shedskin: 'Zrzucenie skóry',
    house: 'Dom',
    plant: 'Typ rośliny',
    planttype: 'Typ rośliny',
    capturehost: 'Przejęcie gospodarza',
    contagion: 'Zaraza',
    lonewolf: 'Samotny wilk',
    hop: 'Podskok',
    decay: 'Rozkład',
    slide: 'Ślizg',
    block: 'Blok',
    poison: 'Trucizna',
    infection: 'Infekcja',
    howl: 'Wycie',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Niedźwiedź może poruszać się o jedno pole w dowolnym kierunku, jak król w szachach',
    bearMovementPost: 'Jest blokowany tylko przez przyjazne figury (z wyjątkiem Drzew, Niedźwiedzie mogą wspinać się na Drzewa!)',
    bearSavage: 'Niedźwiedź może pokonać zdolności obronne jak Blok Nosorożca',
    bearSavagePost: 'Używając Dzikości Niedźwiedź może zbić każdą figurę z dowolnego kierunku, dodając śmiertelności',

    // Crane
    craneMovement: 'Żuraw może poruszać się o 1 lub 2 pola w linii prostej',
    craneMovementPost: 'Żuraw może nawet przelatywać nad innymi figurami!',
    craneBirdType: 'Figury typu ptaka nie mogą bić dużych ani drapieżnych figur',
    craneBirdTypePost: 'Obejmuje to Drzewo, Nosorożca, Niedźwiedzia i Wilka',

    // Frog
    frogMovement: 'Żaba skacze o 2 pola po skosie',
    frogMovementPost: 'Nie może skoczyć tylko o jedno',
    frogWallBlock: 'Jeśli zwykła ścieżka Żaby na 2 pola jest zablokowana przez ścianę lub inną figurę, nie może bić',
    frogWallBlockPost: 'Jej zwykły ruch jest skrócony do 1 pola po skosie',
    frogWallClimb: 'Gdy Żaba znajduje się na ścianie planszy (kolumna A lub E), może poruszać się w górę lub w dół o jedno',
    frogWallClimbPost: 'Chyba że jest zablokowana przez przyjazną figurę lub Nosorożca przed Żabą',
    frogLilypad: 'Jeśli Żaba jeszcze nie ruszyła się w grze, może przeskoczyć na dowolne z pierwszych 3 rzędów jako potężna zdolność obronna',
    frogLilypadPost: 'Może zbić każdą zwykłą figurę używając skoku Lilia wodna, z wyjątkiem Nosorożca na wyższym rzędzie niż ona sama',
    frogPoisonous: 'Gdy jakiekolwiek zwierzę zbije figurę Żaby, zostaje zatrute!',
    frogPoisonousPost: 'Zatruta figura pomija swoją następną dostępną turę przed wyzdrowieniem',

    // Fungi
    fungiMovement: 'Grzyb może poruszać się o jedno pole w dowolnym kierunku',
    fungiMovementPost: 'Jest blokowany tylko przez sojusznicze figury',
    fungiMeadow: 'Grzyb zmniejsza zdolność ruchu wrogiego Drzewa',
    fungiMeadowPost: 'Wróg Drzewa nie może poruszać się w odległości 1 pola od Grzyba',
    fungiParasitic: 'Grzyb może unieruchomić wrogą figurę Drzewa',
    fungiParasiticPost: 'Jeśli Grzyb jest w odległości 1 pola od wroga Drzewa, nie może się ono ruszać, dopóki Grzyb nie odsunie się lub nie zostanie zbity',
    fungiZombification: 'Grzyb może zzombifikować każdą wrogą figurę zwierzęcia, która go zbije, pozwalając kontrolować wrogą figurę przez jedną turę',
    fungiZombificationPost: 'Zzombifikowana figura jest również uważana za figurę Grzyba w tej turze, nawet jeśli Grzyb był twoim królem, gra nie kończy się aż po tej turze',
    fungiFungi: 'Grzyb',
    fungiFungiPost: 'Takich jak trucizna, oplątanie i infekcja wirusem, ale nie zombifikacja, ponieważ może zombifikować innych!',

    // Goat
    goatMovement: 'Koza może poruszać się o jedno pole w dowolnym kierunku',
    goatMovementPost: 'Koza porusza się wolno, ale ma potężne zdolności',
    goatTraverse: 'Koza może przemierzać inne połączone figury, tworząc ogromny potencjał ruchu',
    goatTraversePost: 'Koza nie może przemierzać przez Zemdlone Kozy ani małe figury jak Wirus',
    goatCapture: 'Koza nie może zbić żadnych Drapieżników',
    goatCapturePost: 'Takich jak Niedźwiedź czy Wilk',
    goatFaint: 'Koza może zemdleć, aby uniknąć bicia z wyjątkiem dużych figur jak Drzewo i Nosorożec',
    goatFaintPost: 'Podczas zemdlenia przeciwnicy mogą "stanąć" na zemdlonej kozie, aby powstrzymać jej ruch',

    // Monkey
    monkeyMovement: 'Małpa może poruszać się o jedno pole w dowolnym kierunku',
    monkeyMovementPost: 'Bez innych figur do wykorzystania Małpa ma ograniczony ruch',
    monkeyLeap: 'Małpa, jak w grze w warcaby, może przeskakiwać nad innymi figurami w linii prostej dla ogromnego potencjału ruchu',
    monkeyLeapPost: 'Ale jeśli przeskakuje przez wrogą figurę, Małpa musi rzucić kostką, aby przeżyć skok, szansa 1/6 na zbicie za każdego wroga, przez którego przeskakuje!',
    monkeySwing: 'Jeśli Małpa użyje skoku przez Drzewo, Małpa otrzymuje bonusową turę',
    monkeySwingPost: 'Użycie huśtawki na Drzewie tworzy potężne synergiczne combo między Małpą a figurą Drzewa',
    monkeyConsume: 'Małpa może pochłonąć Grzyba na bonusową turę',
    monkeyConsumePost: 'Prowadząc do niszczycielskich kombinacji w połączeniu z innymi bonusowymi turami',
    monkeyGamble: 'Poza rzucaniem kostką, aby przeskakiwać wrogów, Małpa musi hazardować, aby zbić Niedźwiedzia',
    monkeyGamblePost: 'Małpa musi wyrzucić 5 lub 6 na 6-ściennej kostce, aby zbić Niedźwiedzia lub sama zostaje zbita',

    // Octopus
    octopusMovement: 'Ośmiornica porusza się o jedno pole w dowolnym kierunku',
    octopusCapture: 'Ośmiornica może bić tylko ortogonalnie',
    octopusCapturePost: 'Ośmiornica może bić lub oplatać figury w złożone sposoby, więc zawsze sprawdzaj czerwone bicia i fioletowe oplątania!',
    octopusEntangle: 'Ośmiornica może oplatać sąsiednie wrogie figury, unieruchamiając je, może nawet ruszyć się o pole i oplatać wrogów!',
    octopusEntanglePost: 'Oplątane figury nie mogą się ruszać, dopóki Ośmiornica nie odsunie się lub nie zostanie zbita',
    octopusInk: 'Ośmiornica może użyć atramentu, aby uciec z niebezpiecznych sytuacji, tworząc do 3 cieni',
    octopusInkPost: 'Dezorientując wroga i pozwalając na interesujące zagrywki przynętowe i unikowe',

    // Penguin
    penguinMovement: 'Pingwin ślizga się w linii prostej w swoim ustawionym kierunku, aż ściana lub figura zablokuje jego ruch',
    penguinMovementPost: 'Po ruchu, Pingwin w tej samej turze może ustawić swój końcowy kierunek',
    penguinRotate: 'Na początku meczu Pingwin jest skierowany w dół i musi się obrócić przed możliwością ślizgu, znany również jako śpiący',
    penguinRotatePost: 'Pingwin w dowolnej pozycji może wybrać obrót zamiast ruchu',
    penguinBirdType: 'Pingwin ma ograniczone zdolności bicia, jak Żuraw, nie może bić dużych ani drapieżnych figur jak Drzewo, Nosorożec, Niedźwiedź czy Wilk',
    penguinBirdTypePost: 'Po biciu Pingwin może obrócić się w dowolnym kierunku dla strategicznego pozycjonowania',

    // Rhino
    rhinoMovement: 'Nosorożec porusza się o dwa pola tylko do przodu',
    rhinoMovementPost: 'Nie może poruszać się tylko o 1 pole',
    rhinoBackStep: 'Nosorożec może poruszać się w tył-lewo lub w tył-prawo',
    rhinoCharge: 'Nosorożec raz na grę może przejechać jedno dodatkowe pole do przodu używając zdolności szarży',
    rhinoChargePost: 'Prowadząc do niszczycielskiego potencjału ruchu i bicia',
    rhinoTrample: 'Nosorożec bije wszystkie figury na swojej ścieżce ruchu dzięki Tratowaniu',
    rhinoTramplePost: 'Włączając w to zemdloną figurę Kozy',
    rhinoLane: 'Nosorożec może zamienić się miejscami z inną sojuszniczą figurą, pozwalając na strategiczną grę torami',
    rhinoLanePost: 'Ale tylko jeśli Nosorożec i figura sojusznicza oboje się jeszcze nie ruszali',

    // Snake
    snakeMovement: 'Wąż może poruszać się o 2 pola w dowolnej linii prostej',
    snakeMovementPost: 'Wąż porusza się dokładnie o 2 pola, chyba że jest zablokowany przez ścianę lub przyjazną figurę',
    snakeMoveBlocks: 'Gdy jest zablokowany przez ścianę lub figurę, której nie może zbić, ruch Węża jest skrócony do 1 pola',
    snakeMoveBlocksPost: 'Może nadal poruszać się o dwa pola, nawet jeśli jest pośrednia figura',
    snakeStrike: 'Wąż może uderzyć 3 pola do przodu, jeśli tam jest wróg zwierzę',
    snakeStrikePost: 'O ile żadne pośrednie figury nie blokują jego ścieżki',
    snakeShedskin: 'Raz na grę Wąż może zrzucić skórę i wrócić do pierwszego rzędu, jeśli pole jest wolne',
    snakeShedskinPost: 'To odrodzenie daje Węzowi dodatkowe życie każdej gry',

    // Tree
    treeMovement: 'Drzewo może poruszać się o jedno pole do przodu lub na dowolne pole w swoim rzędzie na boki',
    treeMovementPost: 'O ile jego ścieżka nie jest zablokowana',
    treeHouse: 'Drzewo może pomieścić inne figury, chroniąc je przed wrogami, którzy nie mogą wspinać się na Drzewa. Mogą wspinać się figury jak Niedźwiedź, Żuraw, Żaba, Grzyb, Koza, Małpa, Ośmiornica i Wąż',
    treeHousePost: 'Gdy figura, która może wspiąć się na drzewo, atakuje, bije tylko pomieszczoną figurę, chroniąc Drzewo',
    treeTrample: 'Drzewo jak Nosorożec, bije wszystkie figury na polu, gdy się porusza',
    treeTramplePost: 'Włącznie z zemdloną Kozą',
    treePlant: 'Drzewo jest rośliną, a nie zwierzęciem, więc jest odporne na kilka efektów',
    treePlantPost: 'Takich jak trucizna, zombifikacja, oplątanie i infekcja wirusem!',

    // Virus
    virusMovement: 'Wirus może poruszać się tylko na pola zajęte przez zwierzęta, które są oddalone o dwa pola',
    virusMoveBlocks: 'Wirus może poruszać się tylko o jedno pole, jeśli jest obok ściany',
    virusCaptureHost: 'Gdy Wirus ląduje na (w) dowolnej figurze zwierzęcia, tylko ją infekuje, może dalej kontynuować zwykłą grę będąc zainfekowana',
    virusCaptureHostPost: 'Wirus bije figurę dopiero gdy opuszcza zainfekowanego gospodarza',
    virusContagion: 'Wirus może rozprzestrzeniać się szybko, infekując wielu gospodarzy w jednej turze',
    virusContagionPost: 'Zaraza pozwala Wirusowi wykonać tyle legalnych ruchów, ile chce w każdej turze',

    // Wolf
    wolfMovement: 'Wilk może poruszać się w kształcie L, jak skoczek w szachach',
    wolfMovementPost: 'Nie jest blokowany przez żadne inne figury',
    wolfLoneWolf: 'Wilk',
    wolfLoneWolfPost: 'Wilk uważa się również za samotnego, gdy ma tylko zemdloną Kozę lub sojusznika Wirusa',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Przeciągnij, aby eksplorować • Uszczypnij, aby powiększyć',
    dragToExploreDesktop: '🖱️ Przeciągnij, aby eksplorować • Przewiń, aby powiększyć',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Wstecz',
    next: 'Dalej',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'PIASKOWNICA',
    description: 'Eksperymentuj i ćwicz',
    mode: 'Tryb:',
    modeValue: 'Piaskownica',
    status: 'Status:',
    statusReady: 'Gotowy',
    clearBoard: 'Wyczyść planszę',
  },

  // Multiplayer
  multiplayer: {
    title: 'GRA WIELOOSOBOWA',
    description: 'Znajdź mecz i rywalizuj!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Mecze kwalifikacyjne',
    matchProgress: 'Postęp meczów',
    gamesCompleted: '{games} / 10 rozegranych gier',
    estimatedFinalRating: 'Szacowana ocena końcowa',
    startingRating: 'Ocena początkowa',
    matchesRemaining: 'Pozostało {matches} meczów',
    findPlacementMatch: 'Znajdź mecz kwalifikacyjny',

    // Matchmaking modes
    findMatch: 'Znajdź mecz',
    competitive: 'Rywalizacyjny',
    competitiveDesc: 'Znajdź przeciwników zbliżonych do twojej rangi',
    quick: 'Szybki',
    quickDesc: 'Znajdź mecze rywalizacyjne szybko',
    casual: 'Zwykły',
    casualDesc: 'Bez rankingu - graj dla zabawy!',
    placement: 'Kwalifikacje',
    placementDesc: 'Ukończ 10 meczy, aby uzyskać rangę',
    startSearch: 'Rozpocznij wyszukiwanie',

    // Searching
    searching: 'Wyszukiwanie...',
    mode: 'Tryb:',
    inQueue: 'W kolejce:',
    players: 'gracz',
    playersPlural: 'gracze',
    cancelSearch: 'Anuluj wyszukiwanie',

    // Game info
    status: 'Status:',
    ready: 'Gotowy',
    selectingKing: 'Wybór króla',
    placingPieces: 'Ustawianie figur',
    playing: 'Gra',
    gameType: 'Typ gry:',
    opponent: 'Przeciwnik:',
    opponentElo: 'ELO przeciwnika:',
    unranked: 'Bez rankingu',

    // Piece placement
    dragPieces: 'Przeciągnij figury na planszę',
    lightPieces: 'Jasne figury (Ty)',
    darkPieces: 'Ciemne figury (Ty)',

    // Waiting states
    waitingForOpponent: 'Oczekiwanie na przeciwnika...',
    waitingForKing: 'Oczekiwanie na wybór króla przez przeciwnika...',

    // Warnings
    invalidPlacement: 'Nieprawidłowe ustawienie',
    lightTurn: 'Tura jasnego gracza!',
    darkTurn: 'Tura ciemnego gracza!',
    onlyLightPieces: 'Możesz ustawiać tylko jasne figury!',
    onlyDarkPieces: 'Możesz ustawiać tylko ciemne figury!',
    mustPlaceOnRow: 'Figury {color} muszą być ustawione w rzędzie {row}!',

    // Chat
    chat: 'Czat',
    typeMessage: 'Wpisz wiadomość...',
    send: 'Wyślij',
  },

  // Main Page
  mainPage: {
    title: 'SZACHY ZWIERZĘCE',
    subtitle: 'Gra dla ludzi',
    playersOnline: 'Aktualnie graczy online',
    placement: 'Kwalifikacja',
    placementProgress: 'Kwalifikacja',
    challengeAI: 'Wyzwij AI',
    multiplayer: 'Gra wieloosobowa',
    sandbox: 'Piaskownica',
    tutorials: 'Samouczki',
    shop: 'Sklep',
    collection: 'Kolekcja',
    history: 'Historia',
    analytics: 'Analityka',
    courses: 'Kursy',
    upgradeAccount: 'Ulepsz konto',
    signIn: 'Zaloguj się',
    playAsGuest: 'Graj jako gość',
    welcomeBack: 'Witaj z powrotem! Zazwyczaj grasz jako',

    // Learn the Pieces section
    learnThePieces: 'Poznaj figury',

    // Learn the Rules section
    learnTheRules: 'Poznaj zasady',
    premiseTitle: 'Założenie',
    premiseText: 'Zodiak to alternatywa szachów z UKRYTYM królem z rejestru 13 figur, wybierz unikalny zestaw, a następnie blefuj przeciwnika, aby go pokonać na planszy 5x8',
    selectionTitle: 'Wybór',
    selectionText: 'Aby rozpocząć grę, potajemnie wybierz swojego króla, następnie umieść 5 figur na zmianę z przeciwnikiem, aby stworzyć jeden z ponad 500 miliardów stanów początkowych.',
    objectiveTitle: 'Cel',
    objectiveText: 'Albo odczytaj przeciwnika, aby ZBIĆ jego tajnego króla, albo PRZEPROWADŹ swojego króla przez planszę, aby zdobyć zwycięstwo!',
    competeTitle: 'Rywalizuj',
    competeText: 'Testuj swoje umiejętności w rankingu, rozwijaj nowe osobiste techniki i strategie, awansuj, aby zmierzyć się z najlepszymi!',
    fullRulesButton: 'Pełne oficjalne zasady kliknij tutaj',

    // FAQ section
    faqTitle: 'Najczęściej zadawane pytania',
    faqQuestion1: 'Jaki jest pomysł na szachy Zodiak?',
    faqAnswer1: 'Szachy Zodiak zostały zainspirowane początkowo słowami Bobby\'ego Fischera o jego inspiracji do stworzenia Chess960, chcieliśmy rozwinąć ideę walki z mechanicznym zapamiętywaniem i celebrować ludzką intuicję w niewyobrażalnej głębi!',
    faqQuestion2: 'Po co nam alternatywa dla szachów',
    faqAnswer2: 'Nie potrzebujemy! Zodiak nie chce odciągać ludzi od grania w szachy! To inna opcja z własnymi mocnymi i słabymi stronami, mamy nadzieję, że będziesz się dobrze bawić i pomożesz nam dostosować tę grę, aby ożywić nową rozgrywkę',
    faqQuestion3: 'Jak wygrać w szachach Zodiak?',
    faqAnswer3: 'Są trzy sposoby na wygraną: zbij ukrytego króla przeciwnika, przeprowadź własnego króla na drugą stronę planszy lub w meczu z kontrolą czasu, niech czas przeciwnika upłynie',
    faqQuestion4: 'Czy to jest FAQ?',
    faqAnswer4: 'Tak, możesz spojrzeć na dowolne wymienione pytania w FAQ i jeśli chcesz więcej szczegółów, możesz kliknąć na pytania, a następnie przeczytać następujące szczegóły, takie jak te szczegóły, które teraz czytasz',
    faqQuestion5: 'Ile czasu trwa typowa gra?',
    faqAnswer5: 'Każda gra różni się znacznie! Niektóre gry kończą się w 2 ruchach, a niektóre mogą trwać 30 minut, zazwyczaj są to gry w przedziale 5-15 minut!',
    faqQuestion6: 'Co się dzieje, jeśli nikt nie może wykonać legalnego ruchu?',
    faqAnswer6: 'Jeśli gracz nie może wykonać żadnego legalnego ruchu (pat), gra kończy się remisem. Gra może również zakończyć się remisem przez powtórzenie (ten sam stan planszy 3 razy) lub przez wspólną zgodę graczy!',

    // About section
    aboutButton: 'O grze',
    privacyPolicy: 'Polityka prywatności',
    developerInterface: 'Interfejs dewelopera',
  },

  // About Modal
  about: {
    title: 'O Zodiaku',
    paragraph1: 'Zodiak to szachopodobna gra planszowa łącząca elementy wyboru figur z gier takich jak LoL i DotA, z mechanikami blefowania z pokera lub gier dedukcji społecznej.',
    paragraph2: 'Wczesne wersje gry zostały stworzone w 2014 roku pod nazwą Shadow Chess. W 2018 roku została przeprojektowana do tego, co widzisz dzisiaj, obejmującą rejestr zabawnych figur ze zbalansowanymi, ale unikalnymi wzorcami ruchu i zdolnościami.',
    paragraph3: 'Naszą wizją jest rejestrowanie wszystkich danych rozgrywki użytkowników, aby kontynuować ewolucję gry w celu utrzymania odświeżającej rozgrywki, zachęcając do nowych zagrywek.',
    paragraph4: 'Z gigantyczną przestrzenią przeszukiwania Zodiaku, ukrytymi informacjami i otwierającymi pozycjami planszy mamy nadzieję powstrzymać dominację AI i utrzymać zodiak jako grę dla ludzi!',
  },

  // Privacy Policy
  privacy: {
    title: 'Polityka prywatności',
    lastUpdated: 'Ostatnia aktualizacja',

    introduction: {
      title: 'Wprowadzenie',
      p1: 'Witamy w Zodiac Chess ("my", "nasz" lub "nas"). Zobowiązujemy się chronić twoją prywatność i zapewnić bezpieczne i przyjemne doświadczenie w grze. Niniejsza Polityka prywatności wyjaśnia, jak zbieramy, wykorzystujemy, ujawniamy i chronimy twoje informacje podczas korzystania z naszej strony i gry.',
      p2: 'Korzystając z Zodiac Chess, zgadzasz się na zbieranie i wykorzystywanie informacji zgodnie z tą polityką. Jeśli nie zgadzasz się z naszymi politykami i praktykami, prosimy nie korzystać z naszej usługi.',
      contact: 'Skontaktuj się z nami pod adresem:',
    },

    infoCollect: {
      title: 'Zbierane informacje',
      accountInfo: {
        title: '1. Informacje o koncie',
        item1: 'Adres e-mail: Wymagany do tworzenia konta i komunikacji',
        item2: 'Nazwa użytkownika: Twoja wybrana nazwa wyświetlana',
        item3: 'Hasło: Zaszyfrowane i bezpiecznie przechowywane',
      },
      gameData: {
        title: '2. Dane gry',
        item1: 'Statystyki gry: Wygrane, przegrane, ranking ELO, postęp meczów kwalifikacyjnych',
        item2: 'Dane rozgrywki: Wybory figur, wykonane ruchy, użyte strategie',
        item3: 'Historia meczów: Zapisy rozegranych gier, przeciwnicy',
        item4: 'Zakupy w grze: Przedmioty kosmetyczne i status członkostwa premium',
      },
      technicalData: {
        title: '3. Dane techniczne',
        item1: 'Informacje o urządzeniu: Typ przeglądarki, system operacyjny',
        item2: 'Dane użytkowania: Odwiedzone strony, spędzony czas, używane funkcje',
        item3: 'Pamięć lokalna: Preferencje języka, ustawienia UI, tymczasowy stan gry',
      },
    },

    children: {
      title: 'Prywatność dzieci (zgodność z COPPA)',
      p1: 'Zodiac Chess jest zaprojektowany jako przyjazny dla rodziny i odpowiedni dla graczy w każdym wieku, w tym dzieci. Dbamy szczególnie o zgodność z Children\'s Online Privacy Protection Act (COPPA).',
      p2: 'Dla użytkowników poniżej 13 roku życia: Zalecamy, aby dzieci korzystały z naszego trybu gościnnego, który nie wymaga tworzenia konta ani zbierania danych. Konta gościnne nie mają dostępu do funkcji czatu tekstowego, zapewniając, że dzieci nie są narażone na komunikację z szerszym internetem. Jeśli dziecko utworzy konto, wymagamy zgody rodzica przed zbieraniem jakichkolwiek danych osobowych.',
      p3: 'NIE zbieramy świadomie, nie używamy ani nie udostępniamy danych osobowych dzieci poniżej 13 lat bez zweryfikowanej zgody rodzica.',
      p4: 'Bezpieczeństwo czatu: Czat tekstowy jest automatycznie wyłączony dla wszystkich kont gościnnych/tymczasowych. Posiadacze standardowych kont mają opcję wyłączenia funkcji czatu w ustawieniach konta w dowolnym momencie.',
      parentalRights: 'Rodzice mają prawo do:',
      right1: 'Przeglądu danych osobowych ich dziecka',
      right2: 'Żądania usunięcia danych ich dziecka',
      right3: 'Odmowy dalszego zbierania lub wykorzystywania informacji ich dziecka',
      contactUs: 'Aby skorzystać z tych praw lub jeśli uważasz, że twoje dziecko przekazało nam dane osobowe, skontaktuj się z nami natychmiast pod adresem contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Jak wykorzystujemy twoje informacje',
      item1: 'Zapewnienie i ulepszanie naszych usług gry',
      item2: 'Dopasowanie cię do odpowiednich przeciwników na podstawie poziomu umiejętności',
      item3: 'Śledzenie twojego postępu, statystyk i osiągnięć',
      item4: 'Przetwarzanie płatności za członkostwo premium i przedmioty kosmetyczne',
      item5: 'Wysyłanie ważnych ogłoszeń serwisowych i aktualizacji',
      item6: 'Analizowanie danych rozgrywki w celu poprawy balansu gry i funkcji',
    },

    thirdParty: {
      title: 'Usługi stron trzecich',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Używamy Firebase do uwierzytelniania, przechowywania bazy danych i funkcjonalności wieloosobowej. Firebase może zbierać pewne dane zgodnie z ich polityką prywatności.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Używamy Stripe do przetwarzania płatności za członkostwo premium i zakupy w aplikacji. Stripe obsługuje wszystkie informacje o kartach płatniczych - nigdy nie widzimy ani nie przechowujemy twoich pełnych danych płatniczych.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Nasza strona jest hostowana na Netlify, który może zbierać standardowe dane hostingu internetowego, takie jak adresy IP i logi dostępu.',
      },
      adsense: {
        title: 'Google AdSense (przyszłość)',
        description: 'Możemy wyświetlać reklamy przez Google AdSense. Te reklamy mogą używać plików cookie do personalizacji. W przypadku treści skierowanych do dzieci będziemy pokazywać tylko niespersonalizowane reklamy zgodnie z COPPA.',
      },
      viewPolicy: 'Zobacz ich politykę prywatności',
    },

    cookies: {
      title: 'Pliki cookie i pamięć lokalna',
      description: 'Używamy pamięci lokalnej przeglądarki (podobnej do plików cookie), aby poprawić twoje doświadczenie:',
      item1: 'Preferencje języka: Zapamiętywanie wybranego języka',
      item2: 'Sesja konta: Utrzymywanie zalogowania (współpracuje z Firebase)',
      item3: 'Ustawienia gry: Zapamiętywanie preferencji UI i ustawień piaskownicy',
      item4: 'Pliki cookie reklamowe: Jeśli wyrazisz zgodę, usługi reklamowe stron trzecich mogą używać plików cookie do personalizacji reklam',
    },

    security: {
      title: 'Bezpieczeństwo danych',
      p1: 'Wdrażamy odpowiednie środki bezpieczeństwa w celu ochrony twoich informacji:',
      item1: 'Szyfrowanie haseł: Wszystkie hasła są szyfrowane przy użyciu standardowych metod branżowych',
      item2: 'Bezpieczne połączenia: Szyfrowanie HTTPS dla całej transmisji danych',
      item3: 'Zasady bezpieczeństwa Firebase: Ścisłe kontrole dostępu do bazy danych',
      p2: 'Jednak żadna metoda transmisji przez internet nie jest w 100% bezpieczna. Chociaż staramy się chronić twoje dane, nie możemy zagwarantować absolutnego bezpieczeństwa.',
    },

    retention: {
      title: 'Przechowywanie danych',
      p1: 'Przechowujemy twoje dane w następujący sposób:',
      item1: 'Aktywne konta: Dane są przechowywane, gdy twoje konto jest aktywne',
      item2: 'Nieaktywne konta: Jeśli twoje konto jest nieaktywne przez 10 lat, możemy usunąć twoje dane',
    },

    rights: {
      title: 'Twoje prawa do prywatności',
      description: 'W zależności od twojej lokalizacji możesz mieć następujące prawa:',
      access: {
        title: 'Dostęp:',
        description: 'Żądanie kopii twoich danych osobowych',
      },
      correction: {
        title: 'Korekta:',
        description: 'Żądanie poprawek do twoich danych',
      },
      deletion: {
        title: 'Usunięcie:',
        description: 'Żądanie usunięcia twojego konta i danych',
      },
      portability: {
        title: 'Przenośność danych:',
        description: 'Żądanie twoich danych w formacie przenośnym',
      },
      optOut: {
        title: 'Rezygnacja:',
        description: 'Rezygnacja z komunikacji marketingowej',
      },
      contact: 'Aby skorzystać z któregokolwiek z tych praw, skontaktuj się z nami pod adresem contact@zodiac-chess.com',
    },

    international: {
      title: 'Użytkownicy międzynarodowi',
      p1: 'Zodiac Chess działa z Nowej Zelandii. Jeśli korzystasz z naszej usługi spoza Nowej Zelandii, pamiętaj, że twoje informacje mogą być przekazywane, przechowywane i przetwarzane w Nowej Zelandii i innych krajach, w których działają nasi dostawcy usług.',
      p2: 'Korzystając z naszej usługi, wyrażasz zgodę na przekazanie twoich informacji do krajów poza krajem twojego zamieszkania, które mogą mieć inne przepisy dotyczące ochrony danych.',
    },

    changes: {
      title: 'Zmiany w tej Polityce prywatności',
      description: 'Możemy od czasu do czasu aktualizować tę Politykę prywatności. Powiadomimy cię o wszelkich zmianach, publikując nową Politykę prywatności na tej stronie i aktualizując datę "Ostatnia aktualizacja". Znaczące zmiany będą komunikowane przez e-mail lub widoczne powiadomienie na naszej stronie.',
    },

    contact: {
      title: 'Skontaktuj się z nami',
      description: 'Jeśli masz jakiekolwiek pytania, wątpliwości lub żądania dotyczące tej Polityki prywatności lub naszych praktyk dotyczących danych, skontaktuj się z nami:',
      email: 'E-mail:',
      company: 'Firma:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Regulamin',
    lastUpdated: 'Ostatnia aktualizacja',
    back: 'Wstecz',
    viewPrivacyPolicy: 'Zobacz Politykę Prywatności',
    acknowledgment: 'Korzystając z Zodiac Chess, potwierdzasz, że przeczytałeś, zrozumiałeś i zgadzasz się przestrzegać niniejszego Regulaminu.',
    acceptance: {
      title: '1. Akceptacja Warunków',
      p1: 'Uzyskując dostęp i korzystając z Zodiac Chess („Usługa"), akceptujesz i zgadzasz się przestrzegać niniejszego Regulaminu. Jeśli nie zgadzasz się z tymi warunkami, prosimy nie korzystać z Usługi.',
      p2: 'Zastrzegamy sobie prawo do modyfikacji tych warunków w dowolnym momencie. Dalsze korzystanie z Usługi po wprowadzeniu zmian oznacza akceptację zmodyfikowanych warunków.',
    },
    description: {
      title: '2. Opis Usługi',
      p1: 'Zodiac Chess to internetowa strategiczna gra planszowa z unikalnymi figurami zwierząt o specjalnych zdolnościach. Usługa obejmuje:',
      feature1: 'Rozgrywkę jednoosobową przeciwko przeciwnikom AI',
      feature2: 'Dopasowywanie graczy i grę rywalizacyjną',
      feature3: 'Interaktywne samouczki i materiały edukacyjne',
      feature4: 'Tworzenie konta i śledzenie postępów',
      feature5: 'Opcjonalne funkcje subskrypcji premium',
      feature6: 'Opcje personalizacji kosmetycznej',
    },
    accounts: {
      title: '3. Konta Użytkowników',
      eligibility: {
        title: '3.1 Uprawnienia',
        p1: 'Aby utworzyć konto, musisz mieć ukończone 13 lat. Użytkownicy poniżej 13 roku życia mogą korzystać z trybu gościa pod nadzorem rodziców, ale nie mogą tworzyć kont.',
      },
      responsibilities: {
        title: '3.2 Bezpieczeństwo Konta',
        p1: 'Jesteś odpowiedzialny za:',
        item1: 'Zachowanie poufności hasła',
        item2: 'Wszystkie działania podejmowane na Twoim koncie',
        item3: 'Natychmiastowe powiadomienie nas o nieautoryzowanym użyciu',
        p2: 'Nie ponosimy odpowiedzialności za straty lub szkody wynikające z nieautoryzowanego dostępu do konta.',
      },
      prohibited: {
        title: '3.3 Działania Zabronione',
        p1: 'NIE wolno:',
        item1: 'Udostępniać konta innym osobom',
        item2: 'Używać wielu kont do manipulowania rankingami',
        item3: 'Używać botów, skryptów lub zautomatyzowanych narzędzi do grania',
        item4: 'Nękać, obrażać lub grozić innym graczom',
        item5: 'Wykorzystywać błędów lub usterek dla nieuczciwej przewagi',
        item6: 'Dokonywać inżynierii wstecznej lub próbować uzyskać dostęp do naszego kodu źródłowego',
        p2: 'Naruszenie tych zasad może skutkować zawieszeniem konta lub trwałą blokadą.',
      },
    },
    premium: {
      title: '4. Subskrypcje Premium',
      billing: {
        title: '4.1 Płatności',
        p1: 'Subskrypcje premium są przetwarzane przez Stripe. Kupując subskrypcję premium, upoważniasz nas do cyklicznego obciążania Twojej metody płatności do momentu anulowania.',
        p2: 'Opłaty za subskrypcję:',
        item1: 'Plan miesięczny: Pobierany co miesiąc w rocznicę daty zakupu',
        item2: 'Plan roczny: Pobierany co rok w rocznicę daty zakupu',
        p3: 'Ceny mogą ulec zmianie z 30-dniowym wyprzedzeniem dla aktywnych subskrybentów.',
      },
      cancellation: {
        title: '4.2 Anulowanie',
        p1: 'Możesz anulować subskrypcję w dowolnym momencie poprzez ustawienia konta lub kontaktując się z pomocą techniczną. Anulowanie następuje na koniec bieżącego okresu rozliczeniowego.',
        p2: 'Zachowasz funkcje premium do końca opłaconego okresu, nawet po anulowaniu.',
      },
      refunds: {
        title: '4.3 Zwroty',
        p1: 'Subskrypcje miesięczne: Brak zwrotów za niepełne miesiące. Anuluj w dowolnym momencie, aby zatrzymać przyszłe opłaty.',
        p2: 'Subskrypcje roczne: Pełny zwrot na żądanie w ciągu 7 dni od zakupu. Po 7 dniach zwroty są według naszego uznania.',
        p3: 'Zakupy kosmetyczne: Generalnie bezzwrotne. Skontaktuj się z pomocą techniczną w wyjątkowych okolicznościach.',
      },
    },
    acceptable: {
      title: '5. Zasady Dopuszczalnego Użytkowania',
      p1: 'Zgadzasz się korzystać z Zodiac Chess w sposób pełen szacunku i zgodny z prawem. Zabronione zachowania obejmują:',
      item1: 'Oszukiwanie, hakowanie lub wykorzystywanie mechaniki gry',
      item2: 'Nękanie, mowę nienawiści lub dyskryminujący język',
      item3: 'Spamowanie, reklamy lub nagabywanie',
      item4: 'Udostępnianie nieodpowiednich treści (jeśli czat lub treści tworzone przez użytkowników są włączone)',
      item5: 'Podszywanie się pod innych użytkowników lub członków personelu',
      item6: 'Próby zakłócania lub uszkodzenia Usługi',
      p2: 'Zastrzegamy sobie prawo do badania naruszeń i podejmowania odpowiednich działań, w tym zamknięcia konta i zgłoszenia władzom, jeśli to konieczne.',
    },
    intellectual: {
      title: '6. Prawa Własności Intelektualnej',
      ownership: {
        title: '6.1 Nasze Treści',
        p1: 'Cała zawartość gry, w tym między innymi mechanika gry, grafika, animacje, efekty dźwiękowe, kod i projekt, są własnością Animal Chess Limited lub naszych licencjodawców.',
        p2: 'Otrzymujesz ograniczoną, niewyłączną, nieprzenoszalną licencję na korzystanie z Usługi wyłącznie w celach rozrywki osobistej.',
      },
      userContent: {
        title: '6.2 Treści Użytkownika',
        p1: 'Przesyłając treści (takie jak wiadomości czatu, nazwy użytkownika lub informacje profilowe), udzielasz nam ogólnoświatowej, wolnej od opłat licencji na używanie, wyświetlanie i rozpowszechnianie tych treści w związku z Usługą.',
        p2: 'Oświadczasz, że posiadasz lub masz niezbędne prawa do wszelkich treści, które przesyłasz.',
      },
    },
    disclaimers: {
      title: '7. Wyłączenia odpowiedzialności i ograniczenia',
      p1: 'USŁUGA JEST DOSTARCZANA „TAK JAK JEST" BEZ JAKICHKOLWIEK GWARANCJI, WYRAŹNYCH LUB DOROZUMIANYCH.',
      p2: 'Nie gwarantujemy, że:',
      item1: 'Usługa będzie działać nieprzerwanie i bezbłędnie',
      item2: 'Usterki zostaną naprawione',
      item3: 'Usługa jest wolna od wirusów lub szkodliwych komponentów',
      item4: 'Wyniki korzystania z Usługi spełnią Twoje oczekiwania',
      p3: 'W MAKSYMALNYM ZAKRESIE DOZWOLONYM PRZEZ PRAWO NIE PONOSIMY ODPOWIEDZIALNOŚCI ZA:',
      item5: 'Jakiekolwiek szkody pośrednie, przypadkowe lub wynikowe',
      item6: 'Utratę zysków, danych lub renomy',
      item7: 'Przerwy w działaniu usługi lub utratę danych',
      item8: 'Szkody przekraczające kwotę, którą zapłaciłeś nam w ciągu ostatnich 12 miesięcy',
    },
    privacy: {
      title: '8. Prywatność',
      p1: 'Korzystanie z Usługi podlega również naszej Polityce Prywatności, która wyjaśnia, jak zbieramy, wykorzystujemy i chronimy Twoje dane osobowe.',
      p2: 'Korzystając z Usługi, wyrażasz zgodę na nasze praktyki dotyczące danych opisane w Polityce Prywatności.',
    },
    changes: {
      title: '9. Zmiany Warunków',
      p1: 'Zastrzegamy sobie prawo do modyfikacji niniejszego Regulaminu w dowolnym momencie. Powiadomimy użytkowników o istotnych zmianach poprzez:',
      item1: 'Powiadomienie e-mail dla zarejestrowanych użytkowników',
      item2: 'Widoczne ogłoszenie na stronie internetowej',
      item3: 'Zaktualizowaną datę „Ostatnia aktualizacja" na górze tej strony',
      p2: 'Dalsze korzystanie z Usługi po wprowadzeniu zmian oznacza akceptację zmodyfikowanych warunków.',
    },
    governing: {
      title: '10. Prawo Właściwe',
      p1: 'Niniejszy Regulamin podlega prawu Nowej Zelandii, bez względu na zasady kolizji praw.',
      p2: 'Wszelkie spory wynikające z tych warunków lub korzystania z Usługi będą rozstrzygane przez sądy Nowej Zelandii.',
    },
    contact: {
      title: '11. Dane Kontaktowe',
      p1: 'W przypadku pytań, wątpliwości lub wsparcia dotyczącego niniejszego Regulaminu:',
      email: 'E-mail:',
      company: 'Firma:',
      address: 'Adres:',
    },
    severability: {
      title: '12. Rozdzielność Postanowień',
      p1: 'Jeśli jakiekolwiek postanowienie niniejszych warunków zostanie uznane za niewykonalne lub nieważne, postanowienie to zostanie ograniczone lub wyeliminowane w minimalnym niezbędnym zakresie, a pozostałe postanowienia pozostaną w pełni obowiązujące.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Polityka Plików Cookie',
    lastUpdated: 'Ostatnia Aktualizacja',
    browserInstructions: {
      chrome: 'Ustawienia → Prywatność i bezpieczeństwo → Pliki cookie',
      firefox: 'Ustawienia → Prywatność i bezpieczeństwo → Ciasteczka i dane stron',
      safari: 'Preferencje → Prywatność → Pliki cookie i dane witryn',
      edge: 'Ustawienia → Prywatność, wyszukiwanie i usługi → Pliki cookie',
    },
    cookieTable: {
      name: 'Nazwa Cookie',
      purpose: 'Cel',
      duration: 'Czas trwania',
      type: 'Typ',
    },
    relatedPolicies: {
      title: 'Powiązane Polityki',
      description: 'Aby uzyskać więcej informacji o tym, jak przetwarzamy Twoje dane, zobacz:',
      privacy: 'Polityka Prywatności',
      terms: 'Regulamin',
    },

    introduction: {
      title: 'Wprowadzenie',
      p1: 'Niniejsza Polityka Plików Cookie wyjaśnia, w jaki sposób Zodiac Chess ("my" lub "nas") wykorzystuje pliki cookie i podobne technologie podczas odwiedzania naszej strony internetowej.',
      p2: 'Korzystając z naszej strony internetowej, wyrażasz zgodę na używanie przez nas plików cookie zgodnie z niniejszą polityką. Jeśli się nie zgadzasz, wyłącz pliki cookie w ustawieniach przeglądarki lub nie korzystaj z naszej strony.',
    },
    what: {
      title: 'Czym Są Pliki Cookie?',
      p1: 'Pliki cookie to małe pliki tekstowe, które są umieszczane na Twoim urządzeniu (komputerze, smartfonie, tablecie) podczas odwiedzania strony internetowej. Są szeroko stosowane, aby strony działały efektywnie i dostarczały informacji właścicielom witryn.',
      p2: 'Pliki cookie służą różnym celom, w tym zapamiętywaniu Twoich preferencji, analizowaniu użycia strony i umożliwianiu określonych funkcji.',
    },
    types: {
      title: 'Rodzaje Plików Cookie, Których Używamy',
      necessary: {
        title: '1. Niezbędne Pliki Cookie',
        description: 'Te pliki cookie są niezbędne do prawidłowego funkcjonowania strony. Bez tych plików cookie usługi, o które prosiłeś, nie mogą być świadczone.',
        examples: 'Przykłady:',
        item1: 'Pliki cookie uwierzytelniania - Utrzymują Cię zalogowanym na koncie',
        item2: 'Pliki cookie bezpieczeństwa - Chronią przed oszustwami',
        item3: 'Pliki cookie sesji - Utrzymują stan gry podczas sesji',
        item4: 'Preferencje zgody na pliki cookie - Zapamiętują Twoje wybory dotyczące plików cookie',
      },
      analytics: {
        title: '2. Analityczne Pliki Cookie',
        description: 'Te pliki cookie pomagają nam zrozumieć, jak odwiedzający wchodzą w interakcję z naszą stroną, zbierając anonimowe informacje o odwiedzinach stron, spędzonym czasie i używanych funkcjach.',
        provider: 'Dostawca: Firebase Analytics (Google)',
        purpose: 'Cel:',
        item1: 'Mierzenie ruchu na stronie i zaangażowania użytkowników',
        item2: 'Identyfikowanie popularnych funkcji i stron',
        item3: 'Zrozumienie demografii użytkowników (przedział wiekowy, ogólna lokalizacja)',
        item4: 'Poprawa wydajności strony i doświadczenia użytkownika',
      },
      advertising: {
        title: '3. Reklamowe Pliki Cookie',
        description: 'Te pliki cookie służą do wyświetlania reklam, które są dla Ciebie istotne. Ograniczają również liczbę wyświetleń reklamy i pomagają mierzyć skuteczność kampanii reklamowych.',
        provider: 'Dostawca: Google AdSense',
        purpose: 'Cel:',
        item1: 'Wyświetlanie spersonalizowanych reklam na podstawie Twoich zainteresowań',
        item2: 'Mierzenie wyników i zaangażowania reklam',
        item3: 'Zapobieganie zbyt częstemu wyświetlaniu tej samej reklamy',
        note: 'Uwaga: Subskrybenci Premium nigdy nie widzą reklam, niezależnie od ustawień plików cookie.',
      },
    },
    firstThird: {
      title: 'Pliki Cookie Pierwszej vs Trzeciej Strony',
      firstParty: {
        title: 'Pliki Cookie Pierwszej Strony',
        description: 'Są to pliki cookie ustawiane bezpośrednio przez Zodiac Chess. Używamy ich do podstawowej funkcjonalności strony, uwierzytelniania i zapamiętywania Twoich preferencji.',
      },
      thirdParty: {
        title: 'Pliki Cookie Trzeciej Strony',
        description: 'Są to pliki cookie ustawiane przez zewnętrzne usługi, których używamy, takie jak Google Analytics i Google AdSense. Pliki cookie stron trzecich podlegają politykom prywatności tych dostawców.',
      },
    },
    specific: {
      title: 'Konkretne Pliki Cookie, Których Używamy',
      tableHeader: 'Poniżej znajduje się szczegółowa lista plików cookie używanych na naszej stronie:',
    },
    control: {
      title: 'Jak Kontrolować Pliki Cookie',
      consent: {
        title: '1. Baner Zgody na Pliki Cookie',
        description: 'Podczas pierwszej wizyty na naszej stronie zobaczysz baner zgody na pliki cookie. Możesz:',
        item1: 'Zaakceptuj Wszystkie - Zezwól na wszystkie pliki cookie (niezbędne, analityczne i reklamowe)',
        item2: 'Odrzuć Opcjonalne - Zezwól tylko na niezbędne pliki cookie (bez analityki lub reklam)',
        item3: 'Dostosuj - Wybierz dokładnie, jakie typy plików cookie chcesz zezwolić',
      },
      browser: {
        title: '2. Ustawienia Przeglądarki',
        description: 'Większość przeglądarek internetowych pozwala kontrolować pliki cookie poprzez ich ustawienia. Możesz:',
        item1: 'Zablokować wszystkie pliki cookie',
        item2: 'Akceptować tylko pliki cookie pierwszej strony',
        item3: 'Usuwać pliki cookie po każdej sesji przeglądania',
        item4: 'Przeglądać i usuwać poszczególne pliki cookie',
        links: 'Oto linki do zarządzania plikami cookie dla popularnych przeglądarek:',
      },
      optOut: {
        title: '3. Narzędzia Rezygnacji',
        description: 'W przypadku plików cookie reklamowych możesz zrezygnować ze spersonalizowanych reklam:',
        googleLink: 'Ustawienia Reklam Google',
        googleDesc: ' - Zarządzaj spersonalizowanymi reklamami Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Zrezygnuj z reklam opartych na zainteresowaniach',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Narzędzie rezygnacji specyficzne dla UE',
      },
    },
    impact: {
      title: 'Wpływ Wyłączenia Plików Cookie',
      p1: 'Jeśli wyłączysz lub odmówisz akceptacji plików cookie, pamiętaj że:',
      item1: 'Niektóre części strony mogą nie działać prawidłowo',
      item2: 'Możesz potrzebować ponownie wprowadzić swoje preferencje przy każdej wizycie',
      item3: 'Możesz zostać wylogowany z konta',
      item4: 'Niezbędne pliki cookie są wymagane do działania strony - ich wyłączenie uniemożliwi korzystanie z podstawowych funkcji',
    },
    updates: {
      title: 'Aktualizacje Niniejszej Polityki Plików Cookie',
      p1: 'Możemy od czasu do czasu aktualizować niniejszą Politykę Plików Cookie, aby odzwierciedlić zmiany w naszych praktykach lub z przyczyn prawnych, regulacyjnych lub operacyjnych.',
      p2: 'Powiadomimy Cię o istotnych zmianach, aktualizując datę "Ostatnia Aktualizacja" na górze tej strony. Prosimy o okresowe przeglądanie tej polityki.',
    },
    contact: {
      title: 'Skontaktuj się z Nami',
      p1: 'Jeśli masz pytania dotyczące naszego używania plików cookie lub tej Polityki Plików Cookie, skontaktuj się z nami:',
      email: 'E-mail:',
      company: 'Firma:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pingwin',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Niedźwiedź',
    Crane: 'Żuraw',
    Frog: 'Żaba',
    Fungi: 'Grzyb',
    Goat: 'Koza',
    Monkey: 'Małpa',
    Octopus: 'Ośmiornica',
    Penguin: 'Pingwin',
    Rhino: 'Nosorożec',
    Snake: 'Wąż',
    Tree: 'Drzewo',
    Virus: 'Wirus',
    Wolf: 'Wilk',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
